import { render, staticRenderFns } from "./ItemMaterialTable.vue?vue&type=template&id=0efb6f10"
import script from "./ItemMaterialTable.vue?vue&type=script&lang=js"
export * from "./ItemMaterialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports